module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".size-position-properties">Position</legend>\n    <div class="size-position-properties collapse collapse-target">\n        <div>\n\n            <div class="zmags-input-control small columns">\n                <div class="pull-left">\n                    <label data-unit="px">Left: <input type="number" step="any" class="left" tabindex="1"></label>\n                    ';
 if (showSizeControls || showWidthControls) { ;
__p += '\n                        <label data-unit="px">Width:  <input type="number" step="any" class="width" tabindex="3"></label>\n                    ';
 } ;
__p += '\n                    ';
 if (showLineControls) { ;
__p += '\n                        <label data-unit="px">Length:  <input type="number" step="any" class="width" tabindex="3"></label>\n                    ';
 } ;
__p += '\n                </div>\n\n                <div class="pull-right">\n                    <label data-unit="px">Top:  <input type="number" step="any" class="top" tabindex="2"></label>\n                    ';
 if (showSizeControls) { ;
__p += '\n                        <label data-unit="px">Height: <input type="number" step="any" class="height" tabindex="4"></label>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n\n            <div class="zmags-input-control small columns">\n                <div class="pull-left">\n                    ';
 if (showRotation) { ;
__p += '\n                        <div class="zmags-input-control rotate-controls">\n                            <label data-unit="&deg;">Rotate: <input type="number" class="rotation unit" step="any" tabindex="5"></label>\n                        </div>\n                    ';
 } ;
__p += '\n                </div>\n\n                <div class="pull-right">\n                    ';
 if (showSizeControls) { ;
__p += '\n                        <button class="btn btn-clear fit-to-scene" tabindex="6">Fit proportionally</button>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n\n            ';
 if (showGroupingControls) { ;
__p += '\n            <div class="grouping">\n                <button class="btn btn-white grouping__btn grouping__group">Group</button>\n                <button class="btn btn-white grouping__btn grouping__ungroup">Ungroup</button>\n            </div>\n            ';
 } ;
__p += '\n\n            <div class="arrange-container">\n                <select class="arrange-controls form-control">\n                    <option></option>\n                    <option value="' +
__e( editorConstants.BRING_TO_FRONT.value ) +
'" data-css-class="' +
__e( editorConstants.BRING_TO_FRONT.text ) +
'">To Front</option>\n                    <option value="' +
__e( editorConstants.SEND_BACK.value ) +
'" data-css-class="' +
__e( editorConstants.SEND_BACK.text ) +
'">To Back</option>\n                    <option value="' +
__e( editorConstants.BRING_FORWARD.value ) +
'" data-css-class="' +
__e( editorConstants.BRING_FORWARD.text ) +
'">Forward</option>\n                    <option value="' +
__e( editorConstants.SEND_BACKWARD.value ) +
'" data-css-class="' +
__e( editorConstants.SEND_BACKWARD.text ) +
'">Backward</option>\n                </select>\n            </div>\n\n            <div class="align-container">\n                <select class="align-controls form-control">\n                    <option></option>\n                    <option value="' +
__e( editorConstants.ALIGN_LEFT.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_LEFT.text ) +
'">Align Left</option>\n                    <option value="' +
__e( editorConstants.ALIGN_CENTER.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_CENTER.text ) +
'">Align Center</option>\n                    <option value="' +
__e( editorConstants.ALIGN_RIGHT.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_RIGHT.text ) +
'">Align Right</option>\n                    <option value="' +
__e( editorConstants.ALIGN_TOP.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_TOP.text ) +
'">Align Top</option>\n                    <option value="' +
__e( editorConstants.ALIGN_MIDDLE.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_MIDDLE.text ) +
'">Align Middle</option>\n                    <option value="' +
__e( editorConstants.ALIGN_BOTTOM.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_BOTTOM.text ) +
'">Align Bottom</option>\n                    <option value="' +
__e( editorConstants.DISTRIBUTE_HORIZONTALLY.value ) +
'" data-css-class="' +
__e( editorConstants.DISTRIBUTE_HORIZONTALLY.text ) +
'">Distribute Horizontally</option>\n                    <option value="' +
__e( editorConstants.DISTRIBUTE_VERTICALLY.value ) +
'" data-css-class="' +
__e( editorConstants.DISTRIBUTE_VERTICALLY.text ) +
'">Distribute Vertically</option>\n                </select>\n            </div>\n\n            <label class="block align-to-scene-container">\n                <input type="checkbox" class="align-to-scene" checked>\n                <span class="custom-checkbox"></span>\n                Align to Scene\n            </label>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/SizeAndPositionPropertiesView.tpl
// module id = 1754
// module chunks = 0